<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<app-part-number-changes-additional-input
  (deleteClick)="delete()"
  [additionalIndex]="additionalIndex"
  [additionalTypeCypressTag]="CYPRESS_TAG"
  [baseClass]="styleTag"
  [isInViewMode]="isInViewMode"
  [isDetailSolvedTrial]="isDetailSolvedTrial"
  [labelAdditional]="LABEL_ADDITIONAL"
  [labelNew]="LABEL_NEW">
  <div class="pnc-new-part-number-container">
    <app-input-autocomplete #materialInput
      (inputValueChange)="materialChange($event)"
      [initialValue]="$safeNavigationMigration(material?.material)"
      [inputFormatter]="typeahead.inputTextNumberDescriptionFormatter"
      [invertedColor]="invertedColorElements"
      [labelInformation]="copyButton"
      [messages]="materialMessages"
      [resultFormatter]="typeahead.inputTextNumberDescriptionFormatter"
      [resultsFunction]="searchMaterials"
      [showViewMode]="showViewMode"
      [validators]="validators.material"
      [warningLevel]="materialWarningLevel"
      baseCypressTag="{{baseCypressTag}}"
      label="{{materialLabel}}"
    placeholder="Select the substitute part number"></app-input-autocomplete>
    <app-input-text #quantityInput
      (inputValueChange)="quantityChange($event)"
      [initialValue]="initialValuePipe($safeNavigationMigration(material?.quantity))"
      [invertedColor]="invertedColorElements"
      [messages]="quantityMessages"
      [showViewMode]="showViewMode"
      [validators]="validators.quantity"
      [warningLevel]="quantityWarningLevel"
      baseCypressTag="pnc-solution-quantity"
      label="Quantity"
      maxLength="6"
    placeholder="e.g. 1"></app-input-text>
  </div>
</app-part-number-changes-additional-input>
<ng-template #copyButton>
  @if (isInViewMode) {
    <div>
      <app-tooltip [dynamic]="false" message="Copy part number to clipboard">
        <button (click)="copyMaterialNumber()"
          class="copy-button btn-text-link dark-background"
          [ngClass]="{'view-solution-trial' : isDetailSolvedTrial}"
          data-cy="new-part-number-copy-button">
          <span class="iwp-icon-gen_copy" data-cy="new-part-number-copy-button-icon"></span>
          <span class="text" data-cy="new-part-number-copy-button-text">Copy</span>
        </button>
      </app-tooltip>
    </div>
  }
</ng-template>
